import './index.less';
import { CatalogItem } from '@/shared/types/catalog';
import { MessagesBubbleQuotation } from '@/components/Common/Icons';
import Image from 'next/image';
import { VerticalName } from '@/shared/types/category';
import { WORK_WITH_FACTORIES_DESCRIPTION } from '@/shared/constants/sourcing-marketplace';
import { getCreatorHubProductDetailsPagePath } from '@/shared/utils/sourcing-marketplace-util';
import { useCreateAccountProvider } from '@/lib/context';

interface MobileBottomButtonGroupProps {
  product: CatalogItem;
  onClickSampleBtn: () => void;
}

const MobileBottomButtonGroup = ({ product, onClickSampleBtn }: MobileBottomButtonGroupProps) => {
  const { showSignupDialogFromSourcing } = useCreateAccountProvider();
  const isServices = product?.catalogCategory?.vertical === VerticalName.SERVICES;

  const clickSampleBtn = () => {
    onClickSampleBtn && onClickSampleBtn();
  };

  const openSignup = () => {
    showSignupDialogFromSourcing(
      WORK_WITH_FACTORIES_DESCRIPTION,
      getCreatorHubProductDetailsPagePath(product.id, 'source'),
      'product_details_page',
    );
  };

  return (
    <div className="mobile-bottom-btns-box">
      {!isServices && (
        <div className="order-btn" onClick={clickSampleBtn}>
          <Image src="/images/sourcing/add-sample-to-cart.svg" width={14} height={14} alt="add to cart" />
          <span>Order</span>
        </div>
      )}
      <a onClick={openSignup} className="contact-supplier-btn">
        <MessagesBubbleQuotation />
        <span>Work with supplier</span>
      </a>
    </div>
  );
};

export default MobileBottomButtonGroup;
